import { render, staticRenderFns } from "./mod5-2.vue?vue&type=template&id=2361d2c6&scoped=true&"
import script from "./mod5-2.vue?vue&type=script&lang=js&"
export * from "./mod5-2.vue?vue&type=script&lang=js&"
import style0 from "./mod5-2.vue?vue&type=style&index=0&id=2361d2c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2361d2c6",
  null
  
)

export default component.exports